<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Create Account
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="addIbasUser()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-row>
            <v-col cols="12">
              <v-card>
                <v-form ref="form" lazy-validation>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" class="mt-0 pt-0">
                          <v-text-field
                            label="Name*"
                            v-model="form.name"
                            :rules="rules.required"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-text-field
                            label="Email Address*"
                            v-model="form.emailAddress"
                            :rules="rules.required"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-text-field
                            label="Mobile Number*"
                            v-model="form.mobileNumber"
                            v-mask="'+63 ### #### ###'"
                            masked="false"
                            type="tel"
                            placeholder="+63 XXX XXXX XXX"
                            :rules="rules.required"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-text-field
                            :append-icon="
                              show.password ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            label="Password*"
                            :type="show.password ? 'text' : 'password'"
                            v-model="form.password"
                            :rules="rules.required"
                            @click:append="show.password = !show.password"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          <v-select
                            :items="accountTypes"
                            item-text="name"
                            item-value="value"
                            label="Type*"
                            :rules="rules.required"
                            v-model="form.type"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                  </v-card-text>

                  <v-card-actions class="pb-5">
                    <v-spacer></v-spacer>
                    <v-btn @click.prevent="cancel"> Cancel </v-btn>
                    <v-btn
                      color="primary"
                      :loading="loadingBtn"
                      :disabled="loadingBtn"
                      @click="onSubmit()"
                      class="px-10"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
            <Snackbar />
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmationDiaglog ref="confirm" />
    <Snackbar />
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import Snackbar from "../dialogs/Snackbar.vue";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglogv2.vue";

export default {
  mixins: [ShareableMethods],
  name: "ServiceProviderRequestTopUp",
  components: { Snackbar, ConfirmationDiaglog },
  data() {
    return {
      show: {
        password: false,
      },

      rules: {
        required: [(value) => !!value || "Required."],
      },

      // accountTypes: ["VERIFIER", "APPROVER", "APPROVER-2"],
      accountTypes: [
        {
          name: "VERIFIER",
          value: "VERIFIER",
        },
        {
          name: "APPROVER-1",
          value: "APPROVER",
        },
        {
          name: "APPROVER-2",
          value: "APPROVER2",
        },
      ],
      form: {
        emailAddress: "",
        name: "",
        password: "",
        type: "",
        mobileNumber: "",
        distributorId: 1,
      },

      loadingBtn: false,
    };
  },

  methods: {
    async cancel() {
      if (
        await this.$refs.confirm.open(
          "Confirmation",
          "Are you sure you want to cancel?"
        )
      ) {
        // this.$router.push({ path: "/" });
        this.$refs.form.reset();
      }
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let data = this.form;
      data.distributorId = this.userData.adminLogin.distributorId;
      data.mobileNumber = this.trimMobileNumber(data.mobileNumber);

      await this.$drs
        .post("/broker/drs/service-provider-accounts", data)
        .then((response) => {
          const res = response.data;
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.loadingBtn = false;

          if (res.status) {
            setTimeout(() => {
              this.$refs.form.reset();
              this.$router.push({ path: "accounts" });
            }, 1000);
          }
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },
  },

  created() {},

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
